L.TileLayer.CanvasSphereMask = L.TileLayer.Canvas.extend({

    data: [],
    options: {
        radius: 25000, // in meters
        opacity: 0.1
    },

    initialize: function (options, data)
    {
        L.Util.setOptions(this, options);
        this.data = typeof data === 'object' && data.length > 0 ? data : [];
        this.drawTile = function (canvas, tilePoint, zoom) {
            this.ctx = canvas.getContext('2d');
            //var meterPerPx = 40075016.686 * Math.abs(Math.cos(this._map.getCenter().lat * 180 / Math.PI)) / Math.pow(2, this._map.getZoom() + 8);
            //console.log('METERS PER PIX', meterPerPx);
            var bounds = this._getBounds(tilePoint);
            this._getPoints(bounds, tilePoint);
        };
    },

    addData: function (dataset)
    {
        this.data = dataset;
    },

    setSpheres: function(dataset, r)
    {
        this.data = dataset;
        this.options.radius = r;
        this.redraw();
    },

    _plot_bg: function()
    {
        var ctx = this.ctx;

        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = this.options.bgcolor; //'rgba(72, 174, 191, .1)';
        ctx.fillRect(0, 0, this.options.tileSize, this.options.tileSize);
    },

    _plot: function (ll, size, tilePoint)
    {
        var s = tilePoint.multiplyBy(this.options.tileSize);
        var p = this._map.project(ll);
        var x = Math.round(p.x - s.x);
        var y = Math.round(p.y - s.y);
        var point =  [x, y];
        var ctx = this.ctx;

        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = '#000000';
        ctx.beginPath();
        ctx.arc(point[0], point[1], size, 0, 2 * Math.PI, false);
        ctx.closePath();
        ctx.fill();
    },

    _scale: function (lat, lng)
    {
        var lngRadius = (this.options.radius / 40075017) * 360 / Math.cos(L.LatLng.DEG_TO_RAD * lat),
            latlng2 = new L.LatLng(lat, lng - lngRadius),
            point2 = this._map.latLngToLayerPoint(latlng2),
            point = this._map.latLngToLayerPoint([lat, lng]);
        return Math.max(Math.round(point.x - point2.x), 1);
    },

    _getBounds: function(tilePoint)
    {
        var size = this.options.tileSize,
            radius = this.options.radius;
        var nwPoint = tilePoint.multiplyBy(size);
        var sePoint = nwPoint.add(new L.Point(size, size));
        var center_p = nwPoint.add(new L.Point(size / 2, size / 2));

        var center_ll = this._map.unproject(center_p);
        var r = this._scale(center_ll.lat, center_ll.lng);

        var pad = new L.Point(r, r); //new L.Point(radius, radius);
        nwPoint = nwPoint.subtract(pad);
        sePoint = sePoint.add(pad);
        var bounds = new L.LatLngBounds([this._map.unproject(sePoint), this._map.unproject(nwPoint)]);
        return bounds;
    },

    _getPoints: function(bounds, tilePoint)
    {
        var data = this.data,
            len = data.length,
            ll;

        this._plot_bg();

        for (var i = 0; i < len; i++)
        {
            ll = data[i];
            if (bounds.contains(ll))
            {
                this._plot(ll, this._scale(ll.lat, ll.lng), tilePoint);
            }
        }
    }
});

L.TileLayer.canvasSphereMask = function(options)
{
    var o = new L.TileLayer.CanvasSphereMask(options);
    return o;
};